import { ERROR, PENDING, SUCCESS } from '../../design-system/constants';
import { AllActions } from '../../shared/redux/types';

import * as actions from './actions';
import { DiscussionState, DiscussionStatusState } from './types';

const initialState: DiscussionState = {
    displayAttachmentsRightPanel: false,
};

export const discussionReducer = (
    state: DiscussionState = initialState,
    action: AllActions,
): DiscussionState => {
    switch (action.type) {
        case actions.openAttachmentsPanelAction:
            return {
                ...state,
                displayAttachmentsRightPanel: action.open,
            };
        default:
            return state;
    }
};

export const discussionStatusReducer = (
    state: DiscussionStatusState = {},
    action: AllActions,
): DiscussionStatusState => {
    switch (action.type) {
        case actions.uploadAttachmentRequestAction: {
            const { dossierId, file, sendingMessageId } = action;
            const sendingMessage = state[dossierId].sendingMessage || {};
            return {
                ...state,
                [dossierId]: {
                    ...state[dossierId],
                    sendingMessage: {
                        ...sendingMessage,
                        [sendingMessageId]: {
                            ...sendingMessage[sendingMessageId],
                            postAttachment: {
                                ...(sendingMessage[sendingMessageId] || {}).postAttachment,
                                [file.name]: PENDING,
                            },
                        },
                    },
                },
            };
        }
        case actions.uploadAttachmentSuccessAction: {
            const { dossierId, fileName, sendingMessageId } = action;
            const sendingMessage = state[dossierId].sendingMessage || {};
            return {
                ...state,
                [dossierId]: {
                    ...state[dossierId],
                    sendingMessage: {
                        ...sendingMessage,
                        [sendingMessageId]: {
                            ...sendingMessage[sendingMessageId],
                            postAttachment: {
                                ...(sendingMessage[sendingMessageId] || {}).postAttachment,
                                [fileName]: SUCCESS,
                            },
                        },
                    },
                },
            };
        }
        case actions.uploadAttachmentFailureAction: {
            const { dossierId, fileName, sendingMessageId } = action;
            const sendingMessage = state[dossierId].sendingMessage || {};
            return {
                ...state,
                [dossierId]: {
                    ...state[dossierId],
                    sendingMessage: {
                        ...sendingMessage,
                        [sendingMessageId]: {
                            ...sendingMessage[sendingMessageId],
                            postAttachment: {
                                ...(sendingMessage[sendingMessageId] || {}).postAttachment,
                                [fileName]: ERROR,
                            },
                        },
                    },
                },
            };
        }
        case actions.sendMessageRequestAction: {
            const { dossierId, sendingMessageId } = action;
            return {
                ...state,
                [dossierId]: {
                    ...state[dossierId],
                    sendingMessage: {
                        ...state[dossierId].sendingMessage,
                        [sendingMessageId]: {
                            postContent: PENDING,
                        },
                    },
                    saveDraftMessage: undefined,
                },
            };
        }
        case actions.sendMessageFailureAction: {
            const { dossierId, sendingMessageId } = action;
            return {
                ...state,
                [dossierId]: {
                    ...state[dossierId],
                    sendingMessage: {
                        ...state[dossierId].sendingMessage,
                        [sendingMessageId]: {
                            postContent: ERROR,
                        },
                    },
                },
            };
        }
        case actions.updateMessageRequestAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    updateMessage: PENDING,
                },
            };
        case actions.updateMessageFailureAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    updateMessage: ERROR,
                },
            };
        case actions.getMessageSuccessAction:
            if (!action.sendingMessageId) {
                return {
                    ...state,
                    [action.dossierId]: {
                        ...state[action.dossierId],
                        updateMessage: SUCCESS,
                    },
                };
            }
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    sendingMessage: {
                        ...state[action.dossierId].sendingMessage,
                        [action.sendingMessageId]: undefined,
                    },
                },
            };
        case actions.fetchScheduledMessagesSuccessAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    updateMessage: SUCCESS,
                },
            };
        case actions.getDraftMessageRequestAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDraftMessage: PENDING,
                },
            };
        case actions.getDraftMessageSuccessAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDraftMessage: SUCCESS,
                },
            };
        case actions.getDraftMessageFailureAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDraftMessage: ERROR,
                },
            };
        case actions.saveDraftMessageAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    saveDraftMessage: PENDING,
                },
            };
        case actions.saveDraftMessageSuccessAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    saveDraftMessage: SUCCESS,
                },
            };
        case actions.saveDraftMessageFailureAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    saveDraftMessage: ERROR,
                },
            };
        case actions.getDiscussionAttachmentsRequestAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDiscussionAttachments: PENDING,
                },
            };
        case actions.getDiscussionAttachmentsSuccessAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDiscussionAttachments: SUCCESS,
                },
            };
        case actions.getDiscussionAttachmentsFailureAction:
            return {
                ...state,
                [action.dossierId]: {
                    ...state[action.dossierId],
                    getDiscussionAttachments: ERROR,
                },
            };
        default:
            return state;
    }
};
